// Desabilita Intro com vídeo e habilita apenas o Splash
videoOff();

// Check da Viewport com innerWidth
if (window.innerWidth >= 1960) {
  var deviceScreenPC1920 = window.innerWidth;
} else if (window.innerWidth >= 1680) {
  var deviceScreenPC1680 = window.innerWidth;
} else if (window.innerWidth >= 1440) {
  var deviceScreenPC1440 = window.innerWidth;
} else if (window.innerWidth >= 414) {
  var deviceScreenMobile1 = window.innerWidth;
} else if (window.innerWidth >= 360) {
  var deviceScreenMobile2 = window.innerWidth;
} else {
  var deviceScreenMobile3 = window.innerWidth;
  console.log("Entra #ELSE");
}

// >>>>>>>>>>>>>>>>>>>> Check Device Screen Mode
if (deviceScreenPC1920) {
  console.log( '%cNAVEIA', 'color: limegreen; background-color: black; font-weight: bold');
  console.log( '%c### 🖥️ Desktop <= 1920', 'color: limegreen; background-color: black; font-weight: bold');
  console.log('### View Port Width: ' + window.innerWidth + 'px');
  console.log('### View Port Height: ' + window.innerHeight + 'px');
  console.log('### Função: animaNaveiaPC1');
  window.onscroll = function () {
    naveiaAnimaPC1();
    contaScroll();
  };
}

if (deviceScreenPC1680) {
  console.log( '%cNAVEIA', 'color: yellow; background-color: black; font-weight: bold');
  console.log( '%c### 🖥️ Desktop <= 1680', 'color: yellow; background-color: black; font-weight: bold');
  console.log('### View Port Width: ' + window.innerWidth + 'px');
  console.log('### View Port Height: ' + window.innerHeight + 'px');
  console.log('### Função: animaNaveiaPC2');
  window.onscroll = function () {
    naveiaAnimaPC2();
    contaScroll();
  };
}

if (deviceScreenPC1440) {
  console.log( '%cNAVEIA', 'color: black; background-color: yellowgreen; font-weight: bold');
  console.log( '%c### 💻 Laptop <= 1440px', 'color: yellowgreen; background-color: black; font-weight: bold');
  console.log('### View Port Width: ' + window.innerWidth + 'px');
  console.log('### View Port Height: ' + window.innerHeight + 'px');
  console.log('### Função: animaNaveiaPC3');
  window.onscroll = function () {
    naveiaAnimaPC3();
    contaScroll();
  };
}

if (deviceScreenMobile1) {
  console.log('%cNAVEIA', 'color: yellowgreen; font-weight: bold');
  console.log('%c### 📱 Mobile 1 <= 414px', 'color: yellowgreen; font-weight: bold');
  console.log('### View Port Width: ' + window.innerWidth + 'px');
  console.log('### View Port Height: ' + window.innerHeight + 'px');
  console.log('### Função: naveiaAnimaMob1');
  window.onscroll = function () {
    naveiaAnimaMob1();
    contaScroll();
  };
}

if (deviceScreenMobile2) {
  console.log('%cNAVEIA', 'color: yellowgreen; font-weight: bold');
  console.log('%c### 📱 Mobile 2 <= 360px', 'color: yellowgreen; font-weight: bold');
  console.log('### View Port Width: ' + window.innerWidth + 'px');
  console.log('### View Port Height: ' + window.innerHeight + 'px');
  console.log('### Função: naveiaAnimaMob2');
  window.onscroll = function () {
    naveiaAnimaMob2();
    contaScroll();
  };
}

if (deviceScreenMobile3) {
  console.log('%cNAVEIA', 'color: yellowgreen; font-weight: bold');
  console.log('%c### 📱 Mobile 3 <= 280', 'color: yellowgreen; font-weight: bold');
  console.log('### View Port Width: ' + window.innerWidth + 'px');
  console.log('### View Port Height: ' + window.innerHeight + 'px');
  console.log('### Função: naveiaAnimaMob3');
  console.log(deviceScreenMobile3);
  window.onscroll = function () {
    naveiaAnimaMob3();
    contaScroll();
  };
}

// Set início do padrão Rotate
scrollRotate1(-30);

// Func Anima PC 1 💻 1920
function naveiaAnimaPC1() {
  if (window.innerWidth >= 600 && document.documentElement.scrollTop < 100) {
    scrollRotate1(-30);
  } else if (
    window.innerWidth >= 600 &&
    document.documentElement.scrollTop < 1000
  ) {
    scrollRotate1(-30);
  } else if (document.documentElement.scrollTop < 1700) {
    scrollRotate1(-30);
  } else {
    document.getElementById('divCaixaNaveia').className = 'posCaixaParada';
    document.getElementById('posEsquerda').className = 'invertEsq';
    document.getElementById('posDireita').className = 'invertDir';
    // splashOff();
    videoOn();
    scrollRotate1(-30);
    // console.log('ENTRA EM ELSE #FIM');
  }
}

// Func Anima PC 2 💻 1680
function naveiaAnimaPC2() {
  if (window.innerWidth >= 600 && document.documentElement.scrollTop < 100) {
    scrollRotate1(-30);
  } else if (
    window.innerWidth >= 600 &&
    document.documentElement.scrollTop < 1000
  ) {
    scrollRotate1(-30);
  } else if (document.documentElement.scrollTop < 1680) {
    scrollRotate1(-30);
  } else {
    document.getElementById('divCaixaNaveia').className = 'posCaixaParada';
    document.getElementById('posEsquerda').className = 'invertEsq';
    document.getElementById('posDireita').className = 'invertDir';
    // splashOff();
    videoOn();
    scrollRotate1(-30);
    // console.log('ENTRA EM ELSE #FIM');
  }
}

// Func Anima PC 3 💻 1440
function naveiaAnimaPC3() {
  if (window.innerWidth >= 600 && document.documentElement.scrollTop < 100) {
    scrollRotate1(-30);
  } else if (
    window.innerWidth >= 600 &&
    document.documentElement.scrollTop < 1000
  ) {
    scrollRotate1(-30);
  } else if (document.documentElement.scrollTop < 1630) {
    scrollRotate1(-30);
  } else {
    document.getElementById('divCaixaNaveia').className = 'posCaixaParada';
    document.getElementById('posEsquerda').className = 'invertEsq';
    document.getElementById('posDireita').className = 'invertDir';
    // splashOff();
    videoOn();
    scrollRotate1(-30);
    // console.log('ENTRA EM ELSE #FIM');
  }
}

// Func Anima Mobile 1 📱
function naveiaAnimaMob1() {
  if (window.innerWidth >= 600 && document.documentElement.scrollTop < 100) {
    scrollRotate1(-30);
  } else if (
    window.innerWidth >= 600 &&
    document.documentElement.scrollTop < 1000
  ) {
    scrollRotate1(-30);
  } else if (document.documentElement.scrollTop < 1700) {
    scrollRotate1(-30);
  } else {
    document.getElementById('divCaixaNaveia').className = 'posCaixaParada';
    document.getElementById('posEsquerda').className = 'invertCentro';
    document.getElementById('posDireita').className = 'invertCentro';
    // splashOff();
    videoOn();
    scrollRotate1(-30);
    // console.log('ENTRA EM ELSE #FIM de Anima Mobile 1 📱');
  }
}

// Func Anima Mobile 2 📱
function naveiaAnimaMob2() {
  if (window.innerWidth >= 600 && document.documentElement.scrollTop < 100) {
    scrollRotate1(-30);
  } else if (
    window.innerWidth >= 600 &&
    document.documentElement.scrollTop < 1000
  ) {
    scrollRotate1(-30);
  } else if (document.documentElement.scrollTop < 1750) {
    scrollRotate1(-30);
  } else {
    document.getElementById('divCaixaNaveia').className = 'posCaixaParada';
    document.getElementById('posEsquerda').className = 'invertCentro';
    document.getElementById('posDireita').className = 'invertCentro';
    // splashOff();
    videoOn();
    scrollRotate1(-30);
    // console.log('ENTRA EM ELSE #FIM de Anima Mobile 2 📱 ');
  }
}

// Func Anima Mobile 3 📱
function naveiaAnimaMob3() {
  if (window.innerWidth >= 600 && document.documentElement.scrollTop < 100) {
    scrollRotate1(-30);
  } else if (
    window.innerWidth >= 600 &&
    document.documentElement.scrollTop < 1000
  ) {
    scrollRotate1(-30);
  } else if (document.documentElement.scrollTop < 1500) {
    scrollRotate1(-30);
  } else {
    document.getElementById('divCaixaNaveia').className = 'posCaixaParada';
    document.getElementById('posEsquerda').className = 'invertCentro';
    document.getElementById('posDireita').className = 'invertCentro';
    // splashOff();
    videoOn();
    scrollRotate1(-30);
    console.log('ENTRA EM ELSE #FIM de Anima Mobile 3 📱 ');
  }
}

// FUNCAO ROTACIONAR 1 / LAPTOP + PC
function scrollRotate1(valRotaciona) {
  let valor = valRotaciona;
  let rotacionar = valor + window.pageYOffset / 60;
  let image = document.getElementById('caixaNaveia');
  image.style.transform = 'translateY(45px) rotate(' + rotacionar + 'deg)';
}

// FUNCAO ROTACIONAR 1 / LAPTOP + PC
function scrollRotate1(valRotaciona) {
  let valor = valRotaciona;
  let rotacionar = valor + window.pageYOffset / 60;
  let image = document.getElementById('caixaNaveia');
  image.style.transform = 'translateY(45px) rotate(' + rotacionar + 'deg)';
}

// FUNCAO CALCULA SCROLL
function contaScroll() {
  var altura = document.documentElement.scrollTop;
  // console.log(altura);
}

// FUNÇÃO DESABILITA VIDEO
function videoOff() {
  var videoOn = document.getElementById('videoNaveia');
  videoOn.className = 'displayNone';
}
function videoOn() {
  var videoOff = document.getElementById('videoNaveia');
  videoOff.className = 'displayContents';
  var videoOff = document.getElementById('splashEstatico');
  videoOff.className = 'displayNone';
}

// FUNÇÃO DESABILITA SPLASH
function splashOff() {
  console.log('SPLASH OFF');
}


//ROTAÇÃO BARRA
document.addEventListener('DOMContentLoaded', function() {
  // Configurações
  const velocidadeRotacao = 5000; // Tempo em milissegundos (5 segundos)
  // Selecionar o elemento da barra de anúncios
  const barraAnuncio = document.querySelector('.announcement-bar__message');
  
  if (barraAnuncio) {
  	
    // Obter o texto original
    const textoCompleto = barraAnuncio.childNodes[0].nodeValue.trim();
    
    // Separar as frases usando o símbolo '|'
    const frases = textoCompleto.split('|').map(frase => frase.trim());
    
    // Variável para controlar o índice atual
    let indiceAtual = 0;

    
    // Função para atualizar o texto
    function rotacionarTexto() {
      
      // Avançar para a próxima frase
      indiceAtual = (indiceAtual + 1) % frases.length;
      
      // Atualizar o conteúdo da barra de anúncios
      barraAnuncio.innerHTML = frases[indiceAtual]
    }
    
    // Iniciar a rotação
    // limpa barra
    barraAnuncio.innerHTML = frases[indiceAtual]
    setInterval(rotacionarTexto, velocidadeRotacao);
  }
});

// Fix - Video do topo não travar com o início do video do Youtube na home
document.addEventListener('DOMContentLoaded', function () {
  const bgVideo = document.getElementById('background-video');

  if (!bgVideo) return;

  bgVideo.addEventListener('pause', () => {
    setTimeout(() => {
      bgVideo.play().catch((e) => {
        console.log("Autoplay bloqueado", e);
      });
    }, 100);
  });

  document.addEventListener('click', () => {
    if (bgVideo.paused) {
      bgVideo.play().catch(() => {});
    }
  });

  window.addEventListener('focus', () => {
    if (bgVideo.paused) {
      bgVideo.play().catch(() => {});
    }
  });
});
